import React from 'react';
import { Link } from "react-router-dom";
import '../css/main_banner.css'


class MainBanner extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            banner_text: "",
            banner_text2: "",
            banner_img: ""
        }
    }

    componentWillMount() {
        if (this.props.context !== undefined && this.props.context !== "") {

            if (this.props.context.home !== undefined && this.props.context.home !== "") {
                let banner_text = "";
                let banner_text2 = "";
                let banner_img = "/static/images/img_food_1.jpg";

                if (this.props.context.home.banner !== undefined && this.props.context.home.banner.banner_text !== undefined) {
                    banner_text = this.props.context.home.banner.banner_text
                }

                if (this.props.context.home.banner !== undefined && this.props.context.home.banner.banner_text2 !== undefined) {
                    banner_text2 = this.props.context.home.banner.banner_text2
                }

                if (this.props.context.home.banner !== undefined && this.props.context.home.banner.banner_img !== undefined) {
                    banner_img = this.props.context.home.banner.banner_img
                }

                this.setState({
                    banner_text: banner_text,
                    banner_text2: banner_text2,
                    banner_img: banner_img
                })
            }
        }
    }

    render() {
        return (
            <div className="mainbanner-frame">
                <section>
                    <div className="main_banner_wrap">
                        <div>
                            <img src={this.state.banner_img} alt="" />
                            <div className="main_banner_container">
                                <div className="main_banner_content">
                                    <p>{this.state.banner_text} <br />{this.state.banner_text2}</p>
                                    <div>
                                        <Link to="/order"><img className="start_order" src="/static/images/img_main_start.png" /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}


export default MainBanner


// WEBPACK FOOTER //
// ./src/component/mainBanner.js